import { useState, useEffect, useMemo } from "react";
import { ButtonPrimary } from "../components/Button";
import { trackEvent } from "../utils/analytics";

const Hero = () => {
  const [typedText, setTypedText] = useState("");
  const [isErasing, setIsErasing] = useState(false);
  const [textIndex, setTextIndex] = useState(0);

  const resumeLink = "https://drive.google.com/file/d/1M0TzgRdxl31zHLtJ5yg5sPYKw7lrs733/view?usp=drive_link"

  const handleResumeView = () => {
    trackEvent("resume_view", {
      link_url: resumeLink,
      link_type: "resume",
    });
  };

  const handleResumeDownload = () => {
    trackEvent("resume_download", {
      link_url: resumeLink,
      link_type: "resume",
    });
  };

  const phrases = useMemo(() => [
    { text: "programming" },
    { text: "designing" },
    { text: "cybersecurity" },
    { text: "technology" },
    { text: "web development" },
    { text: "innovation" },
    { text: "AI" },
  ], []);
  
  const typingSpeed = 150;
  const erasingSpeed = 100;
  const delayBeforeErasing = 1000;

  useEffect(() => {
    let timer;

    const typeAndErase = () => {
      const currentPhrase = phrases[textIndex].text;

      if (!isErasing) {
        setTypedText((prev) => currentPhrase.slice(0, prev.length + 1));
      } else {
        setTypedText((prev) => prev.slice(0, prev.length - 1));
      }

      if (typedText === currentPhrase && !isErasing) {
        setTimeout(() => {
          setIsErasing(true);
        }, delayBeforeErasing);
      } else if (typedText === "" && isErasing) {
        setIsErasing(false);
        setTextIndex((prevIndex) => (prevIndex + 1) % phrases.length);
      }
    };

    timer = setTimeout(typeAndErase, isErasing ? erasingSpeed : typingSpeed);

    return () => clearTimeout(timer);
  }, [typedText, isErasing, textIndex, phrases]);

  return (
    <div>
      <section id="home" className="lg:h-[100vh] lg:flex lg:items-center lg:pt-0 pt-28">
        <div className="container items-center">
          <div>
            <div className="flex w-fit items-center gap-3">
              <figure className="img-box w-9 h-9 rounded-lg">
                <img
                  src="./images/people-4.jpg"
                  alt="Avatar"
                  width={40}
                  height={40}
                  className="img-cover"
                />
              </figure>

              <div className="flex items-center gap-1.5 text-zinc-400 text-sm tracking-wide">
                <span className="relative w-2 h-2 rounded-full bg-emerald-400">
                  <span className="absolute inset-0 w-2 h-2 rounded-full bg-emerald-400 animate-ping"></span>
                </span>
                Open for Collaboration
              </div>
            </div>

            <h2 className="headline-1 mt-5 mb-8 lg:mb-10">
              <span className="text-white">
                Hey, I am Pearl.
                I am passionate <br />about{" "}
                <span className="text-emerald-400 !important">
                  {typedText}
                </span>
              </span>
            </h2>

            <div className="flex items-center gap-3 flex-wrap">
              <a
                href={resumeLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-hidden="true"
                tabIndex={-1}
                className="sr-only"
                onMouseEnter={handleResumeView}
                onFocus={handleResumeView}
                onClick={handleResumeDownload}
              >
                Resume
              </a>
              <ButtonPrimary
                href="#about"
                label="Scroll down"
                icon="arrow_downward"
                onClick={() => trackEvent("contact_click", { link_url: "#about", link_type: "section" })}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;